export class UploadedConversationFile {
    id = 0;
    file?:string;
    name?: string;

    deserialize(data: any) {
        this.id = data.id ?? 0;
        this.file = data.file ?? 0;
        this.name = data.name ?? undefined;
        return this;
    }
}
